import {
  createAssetHistorySuppressFilter,
  createDetachedResponseProfile,
  createOnDemandResponseProfile,
} from '../../factories';

const assetHistoryRetrievedProperties = ['assetId', 'assetType', 'duration', 'finishedWatching', 'position'].join(',');

export const assetRetrievedProperties = [
  'endDate',
  'error',
  'id',
  'images',
  'linearAssetId',
  'metas.Adult',
  'metas.ContentMarkerText',
  'metas.EpisodeName',
  'metas.EpisodeNumber',
  'metas.MarkerBackgroundColor',
  'metas.MarkerTextColor',
  'metas.IsMosaicEvent',
  'metas.SeasonNumber',
  'metas.SeriesID',
  'name',
  'recordingId',
  'startDate',
  'tags.BillingId',
  'tags.MosaicInfo',
  'tags.ParentalRating',
  'tags.SeriesName',
  'type',
].join(',');

export function createAssetHistoryResponseProfile({ enableEpisodesGrouping }: { enableEpisodesGrouping: boolean }) {
  return createOnDemandResponseProfile({
    retrievedProperties: assetHistoryRetrievedProperties,
    ...(enableEpisodesGrouping
      ? {
          relatedProfiles: [
            createDetachedResponseProfile({
              name: 'suppress',
              filter: createAssetHistorySuppressFilter({}),
            }),
          ],
        }
      : undefined),
  });
}
